
export { default as useGlobalState } from "./useGlobalState.hooks"